export const getSchoolLocationsUrl = ({
  schoolID,
  version = 'v3',
}: {
  schoolID: string;
  version?: string;
}) => `/api/${version}/schoolAdmin/locations/${schoolID}/all`;
